// 认证初始化服务 - 避免循环依赖
import AuthService from './authService'

export class AuthInitService {
  static isInitialized = false

  /**
   * 初始化认证系统
   */
  static async init() {
    if (this.isInitialized) return

    try {
      // 初始化认证服务
      AuthService.init()
      
      // 检查是否有保存的会话
      const currentUser = AuthService.getCurrentUser()
      const isLoggedIn = AuthService.isLoggedIn()
      
      console.log('🔐 认证系统初始化完成:', isLoggedIn ? '已登录' : '未登录')
      
      this.isInitialized = true
    } catch (error) {
      console.error('❌ 认证系统初始化失败:', error)
    }
  }

  /**
   * 获取当前用户
   */
  static getCurrentUser() {
    return AuthService.getCurrentUser()
  }

  /**
   * 检查是否已登录
   */
  static isLoggedIn() {
    return AuthService.isLoggedIn()
  }
}

export default AuthInitService

